// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var ViewStack = require("../../../reason/common/ViewStack.bs.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Responsive = require("../../../uikit/reason/helpers/Responsive.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var UserSession = require("../../../reason/common/UserSession/UserSession.bs.js");
var Avatar__Jsx3 = require("../../../uikit/reason/atoms/Avatar/Avatar__Jsx3.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var ErrorComponent = require("../../../reason/common/Error/ErrorComponent.bs.js");
var Types__Attachment = require("../../../reason/common/types/Types__Attachment.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var WarningSection__Jsx3 = require("../../../uikit/reason/atoms/Sections/WarningSection__Jsx3.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var ConversationMessageInputForm = require("../ConversationMessageInputForm.bs.js");
var UnsupportedAttachmentsDialog = require("../../../reason/common/Attachments/UnsupportedAttachmentsDialog.bs.js");
var Conversation__ConversationsSection__Common = require("./Conversation__ConversationsSection__Common.bs.js");
var ConversationConversationsSectionReplyInputMutation_graphql = require("../../../__generated__/ConversationConversationsSectionReplyInputMutation_graphql.bs.js");
var Conversation__ConversationsSection__ConversationMessageArea = require("./Conversation__ConversationsSection__ConversationMessageArea.bs.js");
var ConversationConversationsSectionReplyInput_conversation_graphql = require("../../../__generated__/ConversationConversationsSectionReplyInput_conversation_graphql.bs.js");
var ConversationConversationsSectionReplyInput_DeactivatedConversationWarning_conversation_graphql = require("../../../__generated__/ConversationConversationsSectionReplyInput_DeactivatedConversationWarning_conversation_graphql.bs.js");

var convertFragment = ConversationConversationsSectionReplyInput_DeactivatedConversationWarning_conversation_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationConversationsSectionReplyInput_DeactivatedConversationWarning_conversation_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationConversationsSectionReplyInput_DeactivatedConversationWarning_conversation_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationConversationsSectionReplyInput_DeactivatedConversationWarning_conversation_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationConversationsSectionReplyInput_DeactivatedConversationWarning_conversation_graphql.node, convertFragment, fRef);
}

var Fragment_membershipStatusV5_decode = ConversationConversationsSectionReplyInput_DeactivatedConversationWarning_conversation_graphql.Utils.membershipStatusV5_decode;

var Fragment_membershipStatusV5_fromString = ConversationConversationsSectionReplyInput_DeactivatedConversationWarning_conversation_graphql.Utils.membershipStatusV5_fromString;

var Fragment = {
  membershipStatusV5_decode: Fragment_membershipStatusV5_decode,
  membershipStatusV5_fromString: Fragment_membershipStatusV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function Conversation__ConversationsSection__ReplyInput$DeactivatedConversationWarning(props) {
  var conversation = use(props.conversation);
  var deactivatedUserDisplayName = Core__Array.filterMap(Core__Array.filterMap(conversation.participants.edges, (function (x) {
                return x;
              })), (function (x) {
            var match = x.node;
            if (match.__typename !== "Agent") {
              return ;
            }
            var tmp = match.membershipStatus;
            if ((tmp === "ACTIVE" || tmp === "TERMINATED") && tmp !== "ACTIVE") {
              return match.displayName;
            }
            
          }))[0];
  var deactivatedUserName = Core__Option.getOr(deactivatedUserDisplayName, "your recipient");
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(WarningSection__Jsx3.make, {
                    children: "You can't reply as " + (deactivatedUserName + " no longer has an active subscription on TAN")
                  }),
              className: "w-full"
            });
}

var DeactivatedConversationWarning = {
  Fragment: Fragment,
  make: Conversation__ConversationsSection__ReplyInput$DeactivatedConversationWarning
};

var convertFragment$1 = ConversationConversationsSectionReplyInput_conversation_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationConversationsSectionReplyInput_conversation_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationConversationsSectionReplyInput_conversation_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationConversationsSectionReplyInput_conversation_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(ConversationConversationsSectionReplyInput_conversation_graphql.node, convertFragment$1, fRef);
}

var Fragment_conversationVisibilityV5_decode = ConversationConversationsSectionReplyInput_conversation_graphql.Utils.conversationVisibilityV5_decode;

var Fragment_conversationVisibilityV5_fromString = ConversationConversationsSectionReplyInput_conversation_graphql.Utils.conversationVisibilityV5_fromString;

var Fragment$1 = {
  conversationVisibilityV5_decode: Fragment_conversationVisibilityV5_decode,
  conversationVisibilityV5_fromString: Fragment_conversationVisibilityV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

var convertVariables = ConversationConversationsSectionReplyInputMutation_graphql.Internal.convertVariables;

var convertResponse = ConversationConversationsSectionReplyInputMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = ConversationConversationsSectionReplyInputMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, ConversationConversationsSectionReplyInputMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use$2 = RescriptRelay_Mutation.useMutation(convertVariables, ConversationConversationsSectionReplyInputMutation_graphql.node, convertResponse, convertWrapRawResponse);

var Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$2
};

function Conversation__ConversationsSection__ReplyInput(props) {
  var targetConversationMessagesConnectionId = props.targetConversationMessagesConnectionId;
  var __showVisibilityInfo = props.showVisibilityInfo;
  var __withAvatar = props.withAvatar;
  var withAvatar = __withAvatar !== undefined ? __withAvatar : true;
  var showVisibilityInfo = __showVisibilityInfo !== undefined ? __showVisibilityInfo : true;
  var conversation = use$1(props.conversation);
  var match = React.useState(function () {
        return [];
      });
  var setUnsupportedFiles = match[1];
  var match$1 = use$2();
  var mutate = match$1[0];
  var agent = UserSession.useAgentInfo();
  var mutate$1 = function (state, reset, notifyOnFailure, notifyOnSuccess) {
    var match = Belt_Array.partition(state.attachments, (function (attachment) {
            return Types__Attachment.isImage(attachment);
          }));
    mutate({
          connections: [targetConversationMessagesConnectionId],
          input: {
            conversationId: conversation.id,
            files: match[1].map(Conversation__ConversationsSection__Common.attachmentToInput),
            images: match[0].map(Conversation__ConversationsSection__Common.attachmentToInput),
            text: state.text
          }
        }, undefined, undefined, undefined, (function (response, errors) {
            var match = response.replyToConversationV5;
            if (match === undefined) {
              return notifyOnFailure();
            }
            switch (match.__typename) {
              case "ConversationReply" :
                  reset();
                  return notifyOnSuccess(undefined);
              case "ConversationIsReadOnlyError" :
              case "__unselected" :
                  return notifyOnFailure();
              
            }
          }), undefined, undefined);
  };
  var match$2 = ConversationMessageInputForm.useWithAttachments(mutate$1, (function (files) {
          setUnsupportedFiles(function (param) {
                return files;
              });
        }));
  var form = match$2[0];
  var submitDisabled = form.submitting || !form.valid();
  var tmp;
  if (conversation.readOnly) {
    tmp = JsxRuntime.jsx(Conversation__ConversationsSection__ReplyInput$DeactivatedConversationWarning, {
          conversation: conversation.fragmentRefs
        });
  } else {
    var match$3 = conversation.visibility;
    var tmp$1;
    tmp$1 = showVisibilityInfo ? (
        match$3 === "PRIVATE" ? "Reply privately" : "Reply publicly"
      ) : "Reply";
    var match$4 = conversation.visibility;
    var tmp$2;
    tmp$2 = showVisibilityInfo ? (
        match$4 === "PRIVATE" ? "Private reply" : "Public reply"
      ) : "";
    var match$5 = form.status;
    var tmp$3;
    tmp$3 = typeof match$5 !== "object" || match$5.TAG !== "SubmissionFailed" ? null : JsxRuntime.jsx(ErrorComponent.make, {
            message: "An error ocurred while sending the message"
          });
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            withAvatar ? JsxRuntime.jsx(JsxRuntime.Fragment, {
                    children: Caml_option.some(JsxRuntime.jsx(Avatar__Jsx3.make, {
                              src: UserSession.Agent.avatarUrl(agent, undefined, undefined),
                              name: agent.firstName + " " + agent.lastName,
                              size: "tiny"
                            }))
                  }) : null,
            JsxRuntime.jsxs("form", {
                  children: [
                    JsxRuntime.jsx(Conversation__ConversationsSection__ConversationMessageArea.make, {
                          form: form,
                          attachmentsManager: match$2[1],
                          inputRef: props.inputRef,
                          submitButtons: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                                disabled: submitDisabled,
                                children: Caml_option.some(tmp$1)
                              }),
                          focusOnMount: props.focusOnMount,
                          placeholder: tmp$2
                        }),
                    tmp$3
                  ],
                  className: "w-full",
                  onSubmit: (function (e) {
                      e.preventDefault();
                      form.submit();
                    })
                })
          ]
        });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(UnsupportedAttachmentsDialog.make, {
                      files: match[0],
                      onDismiss: (function () {
                          setUnsupportedFiles(function (param) {
                                return [];
                              });
                        })
                    }),
                JsxRuntime.jsx(ViewStack.make, {
                      space: Responsive.make({
                            NAME: "px",
                            VAL: 6
                          }, {
                            NAME: "px",
                            VAL: 10
                          }, undefined, undefined, undefined, undefined, undefined),
                      width: {
                        NAME: "percent",
                        VAL: 100
                      },
                      alignItems: "flexStart",
                      flexDirection: "row",
                      flexGrow: 1,
                      children: Caml_option.some(tmp)
                    })
              ]
            });
}

var Buttons;

var Commons;

var ConversationMessageForm;

var ConversationMessageArea;

var SendMessageButtons;

var make = Conversation__ConversationsSection__ReplyInput;

exports.Buttons = Buttons;
exports.Commons = Commons;
exports.ConversationMessageForm = ConversationMessageForm;
exports.ConversationMessageArea = ConversationMessageArea;
exports.SendMessageButtons = SendMessageButtons;
exports.DeactivatedConversationWarning = DeactivatedConversationWarning;
exports.Fragment = Fragment$1;
exports.Mutation = Mutation;
exports.make = make;
/* commitMutation Not a pure module */
